var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import { TableBodyRowModal } from '../../atoms/Table/TableBodyRow/TableBodyRow';
import { getMatchStatusString } from '../../../types';
import { TableHeaderCellModal } from '../../atoms/Table/TableHeaderCell';
import { TableBodyCellModal } from '../../atoms/Table/TableBodyCell';
import { useAppDispatch } from '../../../hooks';
import { addPlayersFromMatch, loadMatches } from '../../../api';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
import { Delimiter } from '../../atoms/Delimiter';
import { useAsyncExecAction } from '../../../hooks/useAsyncExecAction';
import { Alerts } from '../Alerts/Alerts';
import { TableBody } from '@mui/material';
const commonModalStyles = {
    padding: '30px',
    maxWidth: '750px',
    maxHeight: 'calc(100vh - 50px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
};
const StyledTableCell = styled(TableCell) `
  width: 150px;
  padding: 5px 16px !important;
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const Title = styled.div `
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #000;
`;
const TableCellNumberHeader = styled(TableHeaderCellModal) `
  width: 98px;
`;
const TableCellGameMasterHeader = styled(TableHeaderCellModal) `
  width: 218px;
`;
const TableCellGamersHeader = styled(TableHeaderCellModal) `
  width: 172px;
`;
const TableCellStatusHeader = styled(TableHeaderCellModal) `
  width: 114px;
`;
const TableCellNumberBody = styled(TableBodyCellModal) `
  width: 98px;
`;
const TableCellGameMasterBody = styled(TableBodyCellModal) `
  width: 218px;
`;
const TableCellGamersBody = styled(TableBodyCellModal) `
  width: 172px;
`;
const TableCellStatusBody = styled(TableBodyCellModal) `
  width: 114px;
`;
const TBRow = styled(TableBodyRowModal) `
  font-weight: ${({ shadow }) => (shadow ? '500' : '300')};
  &::before {
    background: ${({ shadow }) => (shadow ? '#2AB2FF' : 'rgba(255, 255, 255, 0.1)')};
  }
  &:nth-child(2n) {
    &::before {
      background: ${({ shadow }) => (shadow ? '#2AB2FF' : 'rgba(255, 255, 255, 0.2)')};
    }
  }
`;
const Buttons = styled.div `
  display: flex;
  flex-direction: row;
  align-self: center;
`;
export function CopyPlayers({ match, setPlayersChanged, onClose }) {
    const { errorHandler } = useErrorHandler();
    // eslint-disable-next-line no-shadow
    const [event, setEvent] = useState(null);
    const [selectedMatch, setSelectedMatch] = useState(null);
    const dispatch = useAppDispatch();
    const matches = useMemo(() => event === null || event === void 0 ? void 0 : event.matches, [event]);
    const { execAsyncAction } = useAsyncExecAction();
    const getMatchesAction = () => __awaiter(this, void 0, void 0, function* () {
        const result = yield loadMatches((match === null || match === void 0 ? void 0 : match.eventId) || '');
        // console.log('Matches getMatches', result)
        setEvent(result);
    });
    const getMatches = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (!(match === null || match === void 0 ? void 0 : match.eventId))
            return;
        yield execAsyncAction({ action: getMatchesAction });
    }), [match, dispatch]);
    useEffect(() => {
        getMatches();
    }, [match, getMatches]);
    // eslint-disable-next-line no-shadow
    const onMatchClick = (match) => {
        if (selectedMatch === match.id)
            setSelectedMatch(null);
        else
            setSelectedMatch(match.id);
    };
    const onSaveClickAction = (copyRoles) => __awaiter(this, void 0, void 0, function* () {
        const response = yield addPlayersFromMatch({
            sourceId: selectedMatch,
            targetId: (match === null || match === void 0 ? void 0 : match.id) || null,
            copyRoles,
        });
        setPlayersChanged(true);
    });
    const onSaveClick = (copy) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield onSaveClickAction(copy);
        }
        catch (err) {
            errorHandler(err);
            console.error('PlayerRole onRoleChange error', err.response);
        }
        onClose();
    });
    return (_jsxs(_Fragment, { children: [_jsx(Alerts, {}), _jsx(Box, Object.assign({ sx: commonModalStyles }, { children: _jsxs(Content, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0438\u0437 \u0438\u0433\u0440\u044B" })), _jsx(Delimiter, { top: "42px" }), _jsx(TableContainer, Object.assign({ component: Paper }, { children: _jsxs(Table, Object.assign({ "aria-label": "customized table" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u2116" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0412\u0435\u0434\u0443\u0449\u0438\u0439" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u0433\u0440\u043E\u043A\u043E\u0432" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0421\u0442\u0430\u0442\u0443\u0441" }))] }) }), _jsx(TableBody, { children: matches === null || matches === void 0 ? void 0 : matches.map((item, index) => {
                                            var _a;
                                            return (_jsxs(TableRow, Object.assign({ onClick: () => onMatchClick(item), selected: selectedMatch === item.id }, { children: [_jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: index + 1 })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: ((_a = item.gameMaster) === null || _a === void 0 ? void 0 : _a.gameName) || '' })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: item.playersCount })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: getMatchStatusString(item.status) }))] }), item.id));
                                        }) })] })) })), _jsx(Delimiter, { top: "40px" }), _jsxs(Buttons, { children: [_jsx(Button, Object.assign({ size: "large", variant: "contained", sx: { width: '224px' }, onClick: () => onSaveClick(false) }, { children: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0431\u0435\u0437 \u0440\u043E\u043B\u0435\u0439" })), _jsx(Delimiter, { right: "30px" }), _jsx(Button, Object.assign({ size: "large", variant: "contained", sx: { width: '224px' }, onClick: () => onSaveClick(true) }, { children: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441 \u0440\u043E\u043B\u044F\u043C\u0438" }))] }), _jsx(Delimiter, { top: "20px" })] }) }))] }));
}
